module.exports = __webpack_public_path__ + "static/media/154-swaziland.b3d95fd9.svg";